import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { isVideoCampaign } from '../../../../../../../services/campaignDimension';
import { isNetworkAccountType } from '../../../../../../account-management';
import { ACCOUNT_ID, ACCOUNT_DESCRIPTION } from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import { ACCOUNT_VIDEO_REPORT_ID } from './accountVideoReportId';
import columnDefinitions from './columnDefinitions';
import footerColumnDefinitions from './footerColumnDefinitions';
import { customColumns, defaultColumns } from './reportPresets';

export const accountVideoReportConfig = {
    id: ACCOUNT_VIDEO_REPORT_ID,
    label: 'Account',
    visibilityCondition: ({ selectedAccount: { type }, dimension, isRealtime }) =>
        isNetworkAccountType(type) && isVideoCampaign(dimension) && !isRealtime,
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-report-by-account',
    rowIdField: ACCOUNT_ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: footerColumnDefinitions,
    searchPlaceholderMsgId: 'app.reports.byAccount.search.placeholder',
    searchField: ACCOUNT_DESCRIPTION.field,
    filters: [
        { id: FILTER_TYPE.COUNTRY },
        { id: FILTER_TYPE.PLATFORM },
        {
            id: FILTER_TYPE.ACCOUNT_MANAGER,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
        {
            id: FILTER_TYPE.SALES_PERSON,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
        {
            id: FILTER_TYPE.ACCOUNT_MANAGER_GROUP,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
        {
            id: FILTER_TYPE.SALES_GROUP,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
    ],
};

export default accountVideoReportConfig;
